import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {Tooltip, IconButton} from '@mui/material'
import {makeStyles} from '@oc/styles'
import {IconByKey} from '@oc/icons'
import {messages} from '../translations'
import {useOcGenericDialogStateContext} from './OcGenericDialogContext'

export interface OcGenericDialogResetFuncParams {
    groupName: string
    fieldName: string
}

interface FieldResetWrapperBaseProps {
    children?: React.ReactNode
    resetLabel?: string
    isChanged?: boolean
    createMode?: boolean
    resetDisabled?: boolean
    rootDivClassName?: string
    inputDivClassName?: string
    iconButtonClassName?: string
}

type FieldResetWrapperProps =
    | (FieldResetWrapperBaseProps & {resetValueFunc?: () => void; resetFuncParams?: undefined})
    | (FieldResetWrapperBaseProps & {resetFuncParams?: OcGenericDialogResetFuncParams; resetValueFunc?: undefined})

const useStyles = makeStyles({
    root: {
        display: 'flex',
        width: '100%'
    },
    paddingTop: {
        paddingTop: '12px'
    },
    flexDiv: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        maxWidth: '100%'
    }
})

function _OcGenericDialogFieldResetWrapper<SourceType>(props: FieldResetWrapperProps) {
    const {
        children,
        isChanged,
        resetValueFunc,
        resetLabel,
        createMode,
        resetDisabled,
        resetFuncParams,
        rootDivClassName,
        inputDivClassName,
        iconButtonClassName
    } = props
    const dialogState = useOcGenericDialogStateContext<SourceType>()
    const {classes, cx} = useStyles()
    const showButton = isChanged && !createMode && !resetDisabled && (!!resetValueFunc || !!resetFuncParams)

    return (
        <div className={rootDivClassName ? cx(classes.root, rootDivClassName) : classes.root}>
            <div className={inputDivClassName ? cx(classes.flexDiv, inputDivClassName) : classes.flexDiv}>
                {children}
            </div>
            {showButton ? (
                <Tooltip title={resetLabel || messages.getText('genericDialog', 'resetTooltip')}>
                    <span className={classes.paddingTop}>
                        <IconButton
                            onClick={
                                resetValueFunc
                                    ? resetValueFunc
                                    : () =>
                                          dialogState.resetField(
                                              resetFuncParams?.groupName || '',
                                              resetFuncParams?.fieldName || ''
                                          )
                            }
                            className={iconButtonClassName ? iconButtonClassName : undefined}
                            size="large"
                        >
                            <IconByKey iconKey="backToStart" color="action" size="16px" />
                        </IconButton>
                    </span>
                </Tooltip>
            ) : undefined}
        </div>
    )
}

export const OcGenericDialogFieldResetWrapper = observer(_OcGenericDialogFieldResetWrapper)
